const invertedMessages = {
  Old: 'external.userManagement.chip.old',
  Actions: 'external.userManagement.label.actions',
};

export default invertedMessages;
